export var ViewOptions;
(function (ViewOptions) {
    ViewOptions["DEFAULT"] = "DEFAULT";
    ViewOptions["POWER"] = "POWER";
    ViewOptions["ACTIVITY"] = "ACTIVITY";
    ViewOptions["TEMPERATURE"] = "TEMPERATURE";
    ViewOptions["LOCATION"] = "LOCATION";
    ViewOptions["SERVICE"] = "SERVICE";
})(ViewOptions || (ViewOptions = {}));
export default ViewOptions;
